// src/sentryClient.ts
//
// PERF — @sentry/react lazy yükleyici. SDK (~35 kB gzip) main chunk'tan
// çıkarılır: HİÇBİR yer @sentry/react'i statik import etmez (yalnız bu modül
// dynamic import() yapar) → webpack ayrı "sentry" chunk'ına böler. Init zaten
// requestIdleCallback ile boot-dışı (index.tsx); bu, modül AĞIRLIĞINI da
// kritik ilk yükten ayırır.
//
// Hata raporlama best-effort: captureExceptionSafe, Sentry yüklü+init ise
// anında raporlar; değilse on-demand yükler. Boot'un ilk ~birkaç saniyesinde
// (init henüz çalışmadan) düşen bir error boundary hatası raporlanmayabilir —
// kabul edilebilir takas (nadir pencere; üretim hatalarının çoğu boot sonrası).
// Asla throw etmez.

type SentryModule = typeof import("@sentry/react");

let mod: SentryModule | null = null;
let loading: Promise<SentryModule | null> | null = null;

export function loadSentry(): Promise<SentryModule | null> {
  if (mod) return Promise.resolve(mod);
  if (loading) return loading;
  loading = import(/* webpackChunkName: "sentry" */ "@sentry/react")
    .then((m) => {
      mod = m;
      return m;
    })
    .catch(() => {
      loading = null; // geçici ağ hatası → tekrar denenebilir
      return null;
    });
  return loading;
}

export function captureExceptionSafe(
  error: unknown,
  ctx?: Record<string, unknown>,
): void {
  if (mod) {
    try {
      mod.captureException(error as any, ctx as any);
    } catch {
      /* no-op */
    }
    return;
  }
  loadSentry()
    .then((m) => {
      if (!m) return;
      try {
        m.captureException(error as any, ctx as any);
      } catch {
        /* no-op */
      }
    })
    .catch(() => {
      /* no-op */
    });
}
